const StringUtils = {
    getExtensionFromFileName: (filename) => {
        filename = filename || "";
        return filename.includes(".") ? filename.split(".").pop() : "file";
    },
};

export default StringUtils;



// WEBPACK FOOTER //
// ./src/components/util/StringUtils.js